export default __webpack_public_path__ + "static/media/planten@2x.1cea6b23.png";